import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import { StyledEngineProvider } from '@mui/material/styles';
import React, { useRef, useEffect } from 'react';

import landingPageTheme from '@/@mantis/theme/landingPageTheme';
import '@/styles/landingPage.css';

// import FloatingVideoPlayer from './components/FloatingVideoPlayer';
import FaqSection from './sections/FaqSection';
import FooterSection from './sections/FooterSection';
import NavSection from './sections/NavSection';
import NewLandingFeaturesSection from './sections/NewLandingFeaturesSection';
import NewLandingHeroSection from './sections/NewLandingHeroSection';
import OurMissionSection from './sections/OurMissionSection';
import PropertyManagerFeaturesSection from './sections/PropertyManagerFeaturesSection';

// Custom wrapper for the landing page
const LandingPageWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Create a theme instance specifically for the landing page
  const theme = createTheme(landingPageTheme);

  // Add preload link for Nohemi font to improve loading on mobile
  useEffect(() => {
    const fontPreloadLinks = [
      { href: '/assets/fonts/Nohemi-Regular.woff2', type: 'font/woff2' },
      { href: '/assets/fonts/Nohemi-SemiBold.woff', type: 'font/woff' },
    ];

    fontPreloadLinks.forEach(font => {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.href = font.href;
      link.as = 'font';
      link.type = font.type;
      link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    });

    return () => {
      fontPreloadLinks.forEach(font => {
        const links = document.querySelectorAll(`link[href="${font.href}"]`);
        links.forEach(link => link.remove());
      });
    };
  }, []);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div style={{ height: '100%', overflowY: 'auto', overflowX: 'hidden' }}>{children}</div>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

const NewLandingPage: React.FC = () => {
  const featuresRef = useRef<HTMLDivElement>(null);

  const scrollToFeatures = () => {
    if (featuresRef.current) {
      featuresRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <LandingPageWrapper>
      <NavSection />
      <NewLandingHeroSection scrollToFeatures={scrollToFeatures} />
      {/* <FloatingVideoPlayer youtubeVideoId="imyLuQ05PKA" /> */}
      <OurMissionSection />
      <PropertyManagerFeaturesSection />
      <NewLandingFeaturesSection ref={featuresRef} />
      <FaqSection />
      <FooterSection />
    </LandingPageWrapper>
  );
};

export default NewLandingPage;
